import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-border-horizontal",
  templateUrl: "./med-icon-border-horizontal.component.html",
})
export class MedIconBorderHorizontalComponent extends SvgMixinComponent {}
